import type { SxProps, Theme } from '@mui/material';

export const MEDICAL_FIELD_GROUP_SX: SxProps<Theme> = {
  border: '1px solid #bec4c8',
  borderRadius: 2,
  p: 1,
};

export const MEDICAL_NUMERIC_GROUP_SX: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  '& > .MuiBox-root': { flex: '0 1 88px', minWidth: 80 },
};

export const MEDICAL_INLINE_NUMBER_SX: SxProps<Theme> = {
  flex: '0 1 88px',
  minWidth: 80,
};

export const MEDICAL_INLINE_TEXT_SX: SxProps<Theme> = {
  flex: '0 1 96px',
  minWidth: 90,
};

export const MEDICAL_STATIC_DIAGNOSIS_SX: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  minHeight: 53,
};
